import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
  NavLink,
} from "reactstrap";
import { Link } from "react-router-dom";
// react component used to create sweet alerts
import SweetAlert from "react-bootstrap-sweetalert";

import LandingPageNavbar from "../../Components/Navbars/LandingPageNavbar";
import TransparentFooter from "../../Components/Footers/TransparentFooter";

import * as actions from "../../store/actions/index";

const ForgotPasswordPage = (props) => {
  const [firstFocus, setFirstFocus] = useState(false);
  const [lastFocus, setLastFocus] = useState(false);
  const [emailAddress, setEmailAddress] = useState("");
  const [password, setPassword] = useState("");
  const [alert, setAlert] = useState(null);
  const [passwordResetAlert, setPasswordResetAlert] = useState(null);

  const errorAlert = (props, show) => {
    setAlert(
      <SweetAlert
        danger
        style={{
          display: "block",
          marginTop: "-100px",
          color: "rgb(89, 89, 89)",
        }}
        title="An error has occured!"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="danger"
        show={show}
      >
        {props.error}
      </SweetAlert>
    );
  };

  const passwordResetErrorAlert = (props, show) => {
    setAlert(
      <SweetAlert
        danger
        style={{
          display: "block",
          marginTop: "-100px",
          color: "rgb(89, 89, 89)",
        }}
        title="A password reset link has been emailed you!"
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="danger"
        show={show}
      >
        {props.passwordResetError}
      </SweetAlert>
    );
  };

  const passwordResetMessageAlert = (show) => {
    setPasswordResetAlert(
      <SweetAlert
        success
        style={{
          display: "block",
          marginTop: "-100px",
          color: "rgb(89, 89, 89)",
        }}
        title="A password reset link has been emailed to you."
        onConfirm={() => hideAlert()}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="info"
        show={show}
      >
        Please check your email for instructions to reset your password.
      </SweetAlert>
    );
  };
  //     setAlert(
  //       <SweetAlert
  //         danger
  //         style={{
  //           display: "block",
  //           marginTop: "-100px",
  //           color: "rgb(89, 89, 89)",
  //         }}
  //         title="Password reset link sent!"
  //         onConfirm={() => hideAlert()}
  //         onCancel={() => hideAlert()}
  //         confirmBtnBsStyle="danger"
  //         show={show}
  //       >
  //         Please check your mail for password reset instructions.
  //       </SweetAlert>
  //     );
  //   };

  const hideAlert = () => {
    setAlert(null);
    props.onAuthFailClear();
  };

  useEffect(() => {
    errorAlert(props, props.error !== null);
  }, [props]);

  useEffect(() => {
    passwordResetMessageAlert(props.passwordReset === true);
  }, [props]);

  useEffect(() => {
    passwordResetErrorAlert(props, props.passwordResetError !== null);
  }, [props]);

  useEffect(() => {
    document.body.classList.add("login-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("login-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  return (
    <>
      <LandingPageNavbar />
      <div className="page-header clear-filter" filter-color="blue">
        <div
          className="page-header-image"
          style={{
            backgroundImage:
              "url(" +
              require("../../assets/img/pexels-photo-2526878.jpeg").default +
              ")",
          }}
        ></div>
        <div className="content">
          <Container>
            {alert}
            {passwordResetAlert}
            <Col className="ml-auto mr-auto" md="4">
              <Card className="card-login card-plain">
                <Form
                  id="login-form"
                  role="form"
                  onSubmit={(event) => {
                    event.preventDefault();
                    props.onPasswordReset(emailAddress);
                  }}
                >
                  <CardHeader className="text-center">
                    <div className="brand">
                      <img
                        alt="..."
                        className="n-logo"
                        src={
                          require("../../assets/img/13244073_1277572828922843_1571284068826816752_o-removebg-preview (1).png")
                            .default
                        }
                      ></img>
                    </div>
                  </CardHeader>
                  <CardBody>
                    <InputGroup
                      className={
                        "no-border input-lg" +
                        (firstFocus ? " input-group-focus" : "")
                      }
                    >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="now-ui-icons ui-1_email-85"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        required
                        placeholder="Email Address"
                        type="text"
                        onFocus={() => setFirstFocus(true)}
                        onBlur={() => setFirstFocus(false)}
                        onChange={(event) =>
                          setEmailAddress(event.target.value)
                        }
                      ></Input>
                    </InputGroup>
                    <InputGroup
                      className={
                        "no-border input-lg" +
                        (lastFocus ? " input-group-focus" : "")
                      }
                    >
                      {/* <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="now-ui-icons objects_key-25"></i>
                        </InputGroupText>
                      </InputGroupAddon> */}
                      {/* <Input
                        required
                        placeholder="Password"
                        type="password"
                        onFocus={() => setLastFocus(true)}
                        onBlur={() => setLastFocus(false)}
                        onChange={(event) => setPassword(event.target.value)}
                      ></Input> */}
                    </InputGroup>
                  </CardBody>
                  <CardFooter className="text-center">
                    <Button
                      block
                      type="submit"
                      className="btn-round"
                      color="info"
                      size="lg"
                    >
                      Forgot Password
                    </Button>
                    {/* <div>
                      <h6>
                        <NavLink
                          to="/SignUp"
                          tag={Link}
                          className="link"
                          // onClick={() => console.log("test")}
                        >
                          Create Account
                        </NavLink>
                      </h6>
                    </div>
                    <div>
                      <h6>
                        <NavLink
                          to="/ForgotPassword"
                          tag={Link}
                          className="link"
                          // onClick={() => console.log("test")}
                        >
                          Forgot Password
                        </NavLink>
                      </h6>
                    </div> */}
                    {/* <div className="pull-right">
                      <h6>
                      <NavLink to="/SignUp" tag={Link} className="link">
                          Need he
                        </NavLink>
                      </h6>
                    </div> */}
                  </CardFooter>
                </Form>
              </Card>
            </Col>
          </Container>
        </div>
        <TransparentFooter />
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    athlete: state.strava.athlete,
    profileImage: state.strava.profileImage,
    firstName: state.strava.firstName,
    lastName: state.strava.lastName,
    city: state.strava.city,
    activities: state.strava.activities,
    error: state.authentication.error,
    passwordReset: state.authentication.passwordReset,
    authenticated: state.authentication.authenticated,
    passwordResetError: state.authentication.passwordResetError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onPasswordReset: (email) => dispatch(actions.passwordReset(email)),
    onAuthFailClear: () => dispatch(actions.authFailClear()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordPage);
